import Api from '@/services/Api'

export default{
  reservations () {
    return Api().get('reservations')
  },
  resources () {
    return Api().get('resources')
  },
  schedule () {
    return Api().get('schedule')
  },
  users () {
    return Api().get('users')
  },
  deleteHour (credentials) {
    return Api().delete('schedule', { data: credentials })
  },
  modifyHour (credentials) {
    return Api().put('schedule', credentials)
  },
  createHour (credentials) {
    return Api().post('schedule', credentials)
  },
  resourceTypes () {
    return Api().get('resourceTypes')
  },
  modifyResource (credentials) {
    return Api().put('resources', credentials)
  },
  createResource (credentials) {
    return Api().post('resources', credentials)
  },
  deleteResource (credentials) {
    return Api().delete('resources', { data: credentials })
  },
  resourcesSchedule (id) {
    return Api().get('resourcesSchedule/' + id)
  },
  resourcesTypes () {
    return Api().get('resourceTypes')
  },
  modifyType (credentials) {
    return Api().put('resourceTypes', credentials)
  },
  createType (credentials) {
    return Api().post('resourceTypes', credentials)
  },
  deleteType (credentials) {
    return Api().delete('resourceTypes', { data: credentials })
  },
  updateDays (credentials) {
    return Api().post('resourcesSchedule', credentials)
  },
  createUser (credentials) {
    return Api().post('register', credentials)
  },
  deleteUser (credentials) {
    return Api().delete('users', {data: credentials})
  },
  updateUser (credentials) {
    return Api().put('users', credentials)
  },
  reservationSearch (value, id) {
    return Api().get('reservationSearch/' + value + '&' + id)
  },
  getHoursResource (id, value) {
    return Api().get('hoursResource/' + id + '&' + value)
  },
  createReservation (credentials) {
    return Api().post('createReservation', credentials)
  },
  getUser (credentials) {
    return Api().post('user', credentials)
  },
  updateProfile (credentials) {
    return Api().put('updateProfile', credentials)
  },
  updatePassword (credentials) {
    return Api().put('updatePassword', credentials)
  },
  deleteReservation (credentials) {
    return Api().delete('reservation', {data: credentials})
  },
  getOwnReservations (userId) {
    return Api().get('ownReservations/' + userId)
  },
  deleteOwnReservations (data) {
    return Api().delete('ownReservations', {data: data})
  }
}



// WEBPACK FOOTER //
// ./src/services/Shared.js